import React from 'react'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'

import { useCurrentUser } from '~/client/hooks/auth'
import { useQuery } from '~/client/hooks/cqrpc'
import Heading from '~/client/components/Heading'
import DocumentEditForm from '~/client/components/DocumentEditForm'
import PrivateProfileEditForm from '~/client/components/PrivateProfileEditForm'
import InspectObject from '~/client/components/InspectObject'

export default function Page() {
  return <Container sx={{mt: 2}} maxWidth='sm'>
    <ProfileChangeForm/>
  </Container>
}

function ProfileChangeForm(){
  const { currentUser } = useCurrentUser()
  return <Stack spacing={2}>
    <Paper sx={{p: 2}}>
      <Heading variant="main">Profile</Heading>
      <Typography variant="body2">Your profile is a shareable document</Typography>
    </Paper>
    <Paper sx={{p: 2}}>
      <DocumentEditForm {...{
        documentId: currentUser.profileId,
      }}/>
    </Paper>
  </Stack>
}
